import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';

import { defineMessages } from '@/lib/i18n';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';

interface ErrorMsg {
  rowIndex: number;
  message: string;
}

interface ValidationResult {
  errorCount: number;
  sdsID: ErrorMsg[];
  pdfName: ErrorMsg[];
  riskAssessDate: ErrorMsg[];
  supplierConfirmationDate: ErrorMsg[];
  tag: ErrorMsg[];
  department: ErrorMsg[];
  productCode: ErrorMsg[];
  assignedUser: ErrorMsg[];
  notes: ErrorMsg[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CsvValidationDialog',
  props: {
  value: {
    type: Boolean,
  },
  totalChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  nameChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  riskAssessDateChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  supplierConfirmationDateChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  departmentChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  tagChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  productCodeChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  assignedUserChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  notesChangedNumber: {
    type: Number,
    default: 0,
    required: false,
  },
  validationErrorMsgs: {
    type: Object as () => ValidationResult,
    default: () => ({
      errorCount: 0,
      sdsID: [],
      pdfName: [],
      riskAssessDate: [],
      supplierConfirmationDate: [],
      tag: [],
      department: [],
      productCode: [],
      assignedUser: [],
      notes: [],
    }),
    required: false,
  },
},
  emits: ["input", "uploadCSV", "closeCsvUploadForm"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'uploadCSV', value: boolean, hideParentModal: boolean): void;
  (e: 'closeCsvUploadForm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  csvValidateModalHeaderTitle: 'このCSVファイルで',
  csvValidateModalHeaderSubTitle: '件のSDSが更新されます。実行しますか？',
  csvValidateWarningFMsg: 'この操作を実行後には取り消しができません。',
  csvValidateWarningSMsg:
    '必ず以下の更新内容にお間違いがないかご確認のうえ実行してください。',
  csvValidateRefMainFMsg: '「実行する」をクリックすると、選択された',
  csvValidateRefMainSMsg: '件のSDSファイルに以下の更新が適用されます。',
  csvValidateRefSubMsg:
    '※ 他部署のSDSを編集できるのは管理者権限での実行時のみです。',
  sdsCountBody: '件の更新',
  sdsVaildateModalCancelHeader: '操作を中止しますか？',
  sdsValidateModalCancelBody:
    '更新プロセスをキャンセルすると、変更内容は適用されません。続行しますか？',
  sdsValidateModalCancelConfirm: '更新を続ける',
  sdsValidateModalCancel: '更新を中止する',
});





const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

// キャンセル確認ダイアログの状態
const cancelConfirmationDialog = ref(false);

// キャンセルボタンクリック時の処理
const showCancelConfirmation = () => {
  cancelConfirmationDialog.value = true;
};

// キャンセル確認ダイアログで「更新を中止する」をクリックした時の処理
const confirmCancel = () => {
  cancelConfirmationDialog.value = false;
  model.value = false;
};

const cancelCsvBulkUpdate = () => {
  cancelConfirmationDialog.value = false;
  model.value = false;
  emit('closeCsvUploadForm');
};

const handleExecuteClick = () => {
  emit('uploadCSV', true, false);
  model.value = false;
};

return { __sfc: true,$t, m, props, emit, model, cancelConfirmationDialog, showCancelConfirmation, confirmCancel, cancelCsvBulkUpdate, handleExecuteClick, BaseFormCard, sharedMessages }
}

})